import { fetchSimDocumentsToken } from "../../authentication/AuthenticationHelper";
import axios from "axios";

interface EditDocumentParams {
    documentReference: string,
    documentTypeGuid: string,
    url: string | null,
    fileName: string | null, 
    comment: string | null,
    languages: string[],
}

export const EditDocumentAsync = async ({
    documentReference,
    documentTypeGuid, 
    url, 
    fileName, 
    comment, 
    languages, 
}: EditDocumentParams) => {
    const token = await fetchSimDocumentsToken();
    
    const body = {
        DocumentTypeGuid: documentTypeGuid,
        Url: url,
        FileName: fileName,
        Comments: comment,
        Languages: languages,
    };
    
    const config = {
        headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    };

    await axios.put(
        `${process.env.REACT_APP_SIM_DOCUMENTS_BASE_URL}/v1/SIMDocuments/Documents/${documentReference}`,
        body,
        config
    );
}

interface EditDateParams {
    documentReference: string,
    startDate: string,
    endDate: string | null,
}

export const EditDateAsync = async ({
    documentReference,
    startDate,
    endDate
}: EditDateParams) => {
    const token = await fetchSimDocumentsToken();
    
    const body = {
        StartDate: startDate,
        EndDate: endDate
    };
    
    const config = {
        headers: { 
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
        }
    };

    await axios.put(
        `${process.env.REACT_APP_SIM_DOCUMENTS_BASE_URL}/v1/SIMDocuments/Documents/${documentReference}/ChangeDate`,
        body,
        config
    );
}
